import { AlkLogger } from '@alk/core';
import { EServerSentEventsClient } from '../../enums';
export class ServerSentEventsClientMock {
    constructor() {
        this.CLOSED = EServerSentEventsClient.CLOSED;
        this.CONNECTING = EServerSentEventsClient.CONNECTING;
        this.OPEN = EServerSentEventsClient.OPEN;
    }
    addEventListener() {
        AlkLogger.debug('[ServerSentEventsClientMock#addEventListener]');
    }
    close() {
        AlkLogger.debug('[ServerSentEventsClientMock#close]');
    }
    init() {
        AlkLogger.debug('[ServerSentEventsClientMock#init]');
    }
    removeEventListener() {
        AlkLogger.debug('[ServerSentEventsClientMock#removeEventListener]');
    }
    getReadState() {
        AlkLogger.debug('[ServerSentEventsClientMock#getReadState]');
        return 0;
    }
    reset() {
        AlkLogger.debug('[ServerSentEventsClientMock#reset]');
    }
}
